import { useCallback, useState } from 'react'

import useLocalStorage from '@/hooks/useLocalStorage'
import utils from '@/utils/utils'

import { initialAuthState } from '../state/initial-state'

export function useAuthState () {
  const [user, setUser] = useState(utils.getUserInfo())
  const [state, setBaseState] = useState(initialAuthState)
  const [isAuth, setIsAuth] = useLocalStorage('isAuth', false)

  const setState = useCallback((patch) => {
    setBaseState((prev) => ({ ...prev, ...patch }))
  }, [])

  const resetState = useCallback((nextState) => {
    setBaseState(nextState)
  }, [])

  const setTurnstileWidgetId = useCallback((turnstileWidgetId) => {
    setBaseState((prev) => {
      if (prev.turnstileWidgetId === turnstileWidgetId) return prev
      return { ...prev, turnstileWidgetId }
    })
  }, [])

  return {
    user,
    setUser,
    state,
    setState,
    resetState,
    setTurnstileWidgetId,
    isAuth,
    setIsAuth,
  }
}
